export const GET_BANK_RECEIPT_RETURN_TRANSACTIONS = 'GET_BANK_RECEIPT_RETURN_TRANSACTIONS';
export const BANK_RECEIPT_RETURN_TRANSACTION_REQUEST = 'BANK_RECEIPT_RETURN_TRANSACTION_REQUEST';
export const BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE = 'BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE';